export default __webpack_public_path__ + "static/logo2-831d14bed9bd30d6978917588cb48fd3.png";